import { Button, Card, CardContent, Grid, MenuItem, Paper, Select, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { IconReportMoney } from '@tabler/icons';
import { useState } from "react";
import { useEffect } from "react";
import { gridSpacing } from "../../constant/Constants";
import { useDispatch } from 'react-redux';
import { closeLoadingApi, openLoadingApi } from "../../redux/create-actions/LoadingAction";
import { showAlert } from "../../redux/create-actions/AlertAction";
import { makeStyles } from "@mui/styles";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import FontSize from "../../layouts/FontSize";
import Color from "../../layouts/Color";
import { graphGetAllContractByCustomer } from "../../services/Contract";
import { graphGetUsageLimiter } from "../../services/CardOperation";
import { graphGenOtp } from '../../services/OneTimePassword';
import { showOtpUsage } from "../../redux/create-actions/OtpAction";
import { MoneyFormatCustom } from "../../utils/function/Function";

const useStyles = makeStyles(function (theme) {
  return {
    gridContainer: {
      [theme.breakpoints.up("sm")]: {
        paddingLeft: '100px',
        paddingRight: '100px'
      },
      [theme.breakpoints.up("md")]: {
        paddingLeft: '150px',
        paddingRight: '150px'
      },
      [theme.breakpoints.up("lg")]: {
        paddingLeft: '200px',
        paddingRight: '200px'
      },
      [theme.breakpoints.only("xl")]: {
        paddingLeft: '20vw',
        paddingRight: '20vw'
      },

    },
  };
});

const paperStyle = { my: { xs: 1, md: 2 }, p: { xs: 1, md: 3 }, minHeight: '100%' };
const container = { mt: 1, textAlign: 'left' };
const buttonSubmit = {
  color: Color.Button,
  backgroundColor: Color.Dangerous,
  '&:hover': { background: Color.Button, color: Color.Dangerous }
};

export default function UsageLimiter() {
  const theme = useTheme();
  const classes = useStyles();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));

  const [contractID, setContractID] = useState(null);
  const [listContract, setListContract] = useState([]);
  const [maxNumber, setMaxNumber] = useState('');
  const [maxAmount, setMaxAmount] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [maxSingleAmount, setMaxSingleAmount] = useState('');

  const dispatch = useDispatch();


  useEffect(() => {
    if (contractID !== null && listContract.length !== 0) {
      let alert = {
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        isOpen: true,
        severity: 'error',
        title: 'Error',
        message: ''
      };

      const usageLimit = graphGetUsageLimiter(contractID);
      usageLimit.then(result => {
        if (result.status === '0') {
          setMaxNumber(result.data.maxNumber);
          setMaxAmount(result.data.maxAmount);
          setMaxSingleAmount(result.data.maxSingleAmount === undefined ? '0' : result.data.maxSingleAmount);
          setDisabled(false);
        } else {
          setMaxNumber('');
          setMaxAmount('');
          setMaxSingleAmount('');
          setDisabled(true)
          alert = { ...alert, message: "Cannot load usage limit for this card!" };
          dispatch(showAlert(alert));
        }
      }).catch((error) => {
        const err = JSON.parse(JSON.stringify(error));
        console.log(err);
        alert = { ...alert, message: 'Server error!' };
        dispatch(showAlert(alert));
      })
    }
  }, [contractID, listContract, dispatch])

  useEffect(() => {
    dispatch(openLoadingApi());

    const promise = graphGetAllContractByCustomer();
    promise.then((result) => {
      setContractID(result.items[0].id);
      setListContract(result.items);
      dispatch(closeLoadingApi());
    }).catch(error => {
      const err = JSON.parse(JSON.stringify(error));
      console.log(err);
      dispatch(closeLoadingApi());
    })
  }, [dispatch]);



  const handleChangeContract = (event) => {
    setContractID(event.target.value);
  };

  const handleChangeMaxNumber = (e) => {
    setMaxNumber(e.target.value);
  };

  const handleChangeMaxAmount = (e) => {
    setMaxAmount(e.target.value);
  };

  const handleChangeMaxSingerAmount = (e) => {
    setMaxSingleAmount(e.target.value);
  };

  const handleUpdateUsageLimit = () => {
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: ''
    };

    const variablesUsage = {
      "contractId": parseInt(contractID),
      "maxAmount": parseInt(maxAmount),
      "maxNumber": parseInt(maxNumber),
      "maxSingleAmount": parseInt(maxSingleAmount)
    }

    dispatch(openLoadingApi());
    let sendOtp = graphGenOtp();
    sendOtp
      .then(result => {
        dispatch(closeLoadingApi())

        if (result === 'SMS') {
          alert = { ...alert, severity: 'info', title: 'Information', message: "Please enter the OTP code sent to your phone number " };
          dispatch(showAlert(alert));
          dispatch(showOtpUsage(variablesUsage, "USAGE_LIMITER"));
        } else {
          alert = { ...alert, severity: 'info', title: 'Information', message: "Please enter the OTP code in your Google Authenticator App" };
          dispatch(showAlert(alert));
          dispatch(showOtpUsage(variablesUsage, "USAGE_LIMITER"));
        }
      }).catch(function (error) {
        const err = JSON.parse(JSON.stringify(error));
        dispatch(closeLoadingApi())
        alert = { ...alert, message: err.response.errors[0].message };
        dispatch(showAlert(alert));
      })
  };

  return (contractID !== null && listContract.length !== 0) && (
    <Paper variant="outlined" sx={paperStyle}>
      <Grid container alignContent="center" justifyContent="space-between">
        <Button id="change-pin" endIcon={<IconReportMoney />} sx={{ color: theme.typography.h3, cursor: 'default', fontSize: FontSize.Normal }}>
          Usage Limiter
        </Button>
      </Grid>
      <Card>
        <CardContent sx={{ pt: '0px' }}>
          <Grid
            container
            spacing={gridSpacing}
            className={classes.gridContainer}
            alignItems="center"
            justifyContent="center"
            sx={container}
          >
            {matchDownSM ? (
              <></>
            ) : (
              <Grid item md={3} xs={12}>
                <Typography variant="h4"> Card Number:</Typography>
              </Grid>
            )}

            <Grid item md={9} xs={12}>
              <Select
                fullWidth
                labelId="cardnumberl-filter"
                id="demo-simple-select-helper"
                value={contractID}
                onChange={handleChangeContract}
                size="medium"
                sx={{
                  '& .MuiInputBase-input': {
                    bgcolor: theme.palette.background.default
                  },
                  bgcolor: theme.palette.background.default,
                }}
              >
                {
                  listContract?.map((contract) => {
                    return (
                      <MenuItem key={contract.id} id={contract.id} value={contract.id}>
                        {(contract.contractNumber).slice(0, 4)}&emsp;{(contract.contractNumber).slice(4, 8).replace("__", "**")}&emsp;{(contract.contractNumber).slice(8, 12).replace("____", "****")}&emsp;{(contract.contractNumber).slice(12, 16)}
                      </MenuItem>
                    )
                  })
                }
              </Select>

            </Grid>
            <Grid item md={3} xs={12}>
              <Typography variant="h4">Max transactions per day:</Typography>
            </Grid>
            <Grid item md={9} xs={12}>
              <TextField
                id="max-number"
                label="Max transactions per day"
                variant="standard"
                fullWidth
                onChange={handleChangeMaxNumber}
                value={maxNumber}
                disabled={disabled}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <Typography variant="h4">Max amount per day:</Typography>
            </Grid>
            <Grid item md={9} xs={12}>
              <TextField
                id="max-amount"
                label="Max transactions per day"
                variant="standard"
                name="max amount"
                fullWidth
                onChange={handleChangeMaxAmount}
                value={maxAmount}
                disabled={disabled}
                InputProps={{
                  inputComponent: MoneyFormatCustom
                }}
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <Typography variant="h4">Max amount per transaction:</Typography>
            </Grid>
            <Grid item md={9} xs={12}>
              <TextField
                id="max-singer-amount"
                label="Max transactions per day"
                variant="standard"
                name="max single amount"
                fullWidth
                onChange={handleChangeMaxSingerAmount}
                value={maxSingleAmount}
                disabled={disabled}
                InputProps={{
                  inputComponent: MoneyFormatCustom
                }}
              />
            </Grid>
            {matchDownSM ? (
              <></>
            ) : (
              <Grid item sm={0} xs={0} md={3} xl={3}></Grid>
            )}
            <Grid item sm={12} xs={12} md={9} xl={9} sx={{ textAlign: `${matchDownSM ? 'center' : 'left'}`, }}>
              <Button
                sx={buttonSubmit}
                variant="contained"
                onClick={handleUpdateUsageLimit}
                endIcon={<KeyboardArrowUpIcon></KeyboardArrowUpIcon>}
                disabled={disabled}
              >
                Submit</Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Paper>
  )
}